import { Component } from 'react';
import { Error } from '@intigral/shared';
import { errorMessage, playerTypes } from '@libs/constants';
import h from '../../../../helpers/common';
import { GenericBitmovinPlayer } from '../../../player';
import { iTrailerProps } from '../../types/iDetailOverlay';

export const Trailer: React.FC<iTrailerProps> = ({ source, isMuted, children, item, playerReadyCallback }) => {
    return (
        <>
            {children}
            <ErrorBoundary>
                <GenericBitmovinPlayer
                    streamingUrl={source}
                    playerType={playerTypes.Trailer}
                    isMuted={isMuted}
                    VODAsset={item}
                    playerReadyCallback={playerReadyCallback}
                />
            </ErrorBoundary>
        </>
    );
};

type ErrorBoundaryState = {
    hasError: boolean;
    error?: any | null;
};

class ErrorBoundary extends Component<any, ErrorBoundaryState> {
    constructor(props: any) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error: any): Partial<ErrorBoundaryState> {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error };
    }

    render() {
        if (this.state.hasError) {
            return (
                <Error
                    icon="exclamation-mark"
                    iconColor="red"
                    absolute
                    errorPairs={[
                        { title: 'Ooops..', text: h.getLang() === 'ar' ? errorMessage.MSG_AR : errorMessage.MSG_EN },
                    ]}
                />
            );
        }

        return this.props.children;
    }
}
